import Swal from "sweetalert2";

export type AlertIconType = "success" | "error" | "warning" | "info" | "question";

const GENERIC_TITLES = new Set([
  "success",
  "success!",
  "error",
  "error!",
  "warning",
  "warning!",
  "info",
  "info!",
  "alert",
  "alert!",
]);

export const AlertDialog = (
  title: string | null | undefined,
  text: string,
  icon: AlertIconType = "info",
  timer: number = 0,
  showConfirmButton: boolean = false,
  showCancelButton: boolean = false,
  confirmButtonText: string = "Confirm",
  cancelButtonText: string = "Cancel",
  okAction?: () => void | Promise<void>,
  cancelAction?: () => void | Promise<void>
) => {
  // If title is generic (e.g. "Success!", "Error!"), only show the actual message (text) as a single clean text
  const cleanTitle = (title || "").trim();
  const cleanText = (text || "").trim();
  const isGenericTitle = !cleanTitle || GENERIC_TITLES.has(cleanTitle.toLowerCase());

  const displayTitle = isGenericTitle ? (cleanText || cleanTitle) : cleanTitle;
  const displayText = isGenericTitle ? undefined : (cleanText && cleanText !== cleanTitle ? cleanText : undefined);

  // Auto-dismiss after 2000ms if no action buttons
  const autoTimer = timer !== 0 ? timer : (!showConfirmButton && !showCancelButton ? 2000 : undefined);

  return Swal.fire({
    title: displayTitle || undefined,
    text: displayText,
    icon: icon,
    timer: autoTimer,
    timerProgressBar: !showConfirmButton && !showCancelButton,
    showConfirmButton: showConfirmButton,
    showCancelButton: showCancelButton,
    confirmButtonText: confirmButtonText || "Confirm",
    cancelButtonText: cancelButtonText || "Cancel",
    buttonsStyling: false,
    customClass: {
      confirmButton: "swal2-confirm",
      cancelButton: "swal2-cancel",
    },
  }).then(async (result) => {
    if (result.isConfirmed && okAction) {
      await okAction();
    } else if (result.isDismissed && cancelAction) {
      await cancelAction();
    }
    return result;
  });
};

export default AlertDialog;
